import React from 'react';
import styled from 'styled-components';

import { NoImage } from '@lt/components/icons-react/userflow';

const EmptyGallery = (): JSX.Element => {
  return (
    <StyledEmptyGalleryContainer>
      <StyledNoImageIcon />
      Нет фото
      <br /> номера
    </StyledEmptyGalleryContainer>
  );
};

const StyledEmptyGalleryContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;

  justify-content: center;
  align-items: center;
  text-align: center;

  background: #f5f3f2;
  color: #919499;

  width: 160px;

  @media (max-width: 459px) {
    width: 90px;
  }
`;

const StyledNoImageIcon = styled(NoImage)`
  height: 24px;
  margin-bottom: 5px;
`;

export default EmptyGallery;
